<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>                
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
               
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">

            <div class="card" v-if="currentStep == 0" title="Initial Care Plan Details">
                <div class="card-header">
                    <h3 class="card-title">Plan Information </h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">

                            <div class="row mb-3">
                                <div class="form-label">Start date</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="startDate"
                                    placeholder=""
                                    v-model="step[currentStep].startDate"
                                    :class="{'is-invalid': v$.step[currentStep].startDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[currentStep].startDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                    
                            <div class="row mb-3">
                                <div class="form-label">Next Review (Plan Expiration)</div>
                                <input
                                    type="date"
                                    class="form-control  w-75"
                                    name="expirationDate"
                                    placeholder=""
                                    v-model="step[currentStep].expirationDate"
                                    :class="{'is-invalid': v$.step[currentStep].expirationDate.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[currentStep].expirationDate.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="form-label">Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="registeredNurseSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[currentStep].registeredNurseSignature"
                                    :class="{'is-invalid': v$.step[currentStep].registeredNurseSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[currentStep].registeredNurseSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">       
                        </div>
                    </div>
                </div>
                
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" href="#" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Back</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>                
            </div>                            

        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';
import moment from 'moment';

export default {
    name: "initialNursingCarePlanCreateComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation", "cancelUrl"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {
       
        // If copying, assign carePlan object to a variable
        if (this.operation == 'store') {
            var carePlanObject = {};                                                      
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'update') {            
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['activity_care_plan'] = JSON.parse(carePlanObject['activity_care_plan']);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + carePlanObject.id + '/' + process.env.MIX_API_KEY; 
        }
        else if (this.operation == 'copy') {
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['activity_care_plan'] = JSON.parse(carePlanObject['activity_care_plan']);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/care-plans/" + process.env.MIX_API_KEY;       
        }

        // Returs empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(carePlanType = null, fieldName, defaultValue = "") {      
            // Editing
            if (!_.isEmpty(carePlanObject)) { 
                if (carePlanType == null) {
                    if (fieldName == 'starts_at' || fieldName == 'expires_at') {
                        return carePlanObject[fieldName] != null ? carePlanObject[fieldName].split(' ')[0] : defaultValue;
                    } else {
                        return carePlanObject[fieldName] ?? defaultValue;               
                    }
                } else {
                    return carePlanObject[carePlanType][fieldName] ?? "";
                }
            } else {
                return defaultValue;
            }
        }

  

        return {
            currentStep: 0, // The step[] array starts with 0 (Ex. a 3 step form will have indexes step[0], step[1], step[2])
            maxStep: 1, // maxStep needs to include the extra 'finish step' (Ex. so a 3 step form will have an index step[3] )
            percentageComplete: 0,
            errors: 0,
            host: document.location.origin,
            endpoint: endpointToUse,
            step: [
                // Step 0 - Plan Information
                {
                    startDate:returnValueFromObject(null,'starts_at'),
                    expirationDate:returnValueFromObject(null,'expires_at'),
                    registeredNurseSignature:returnValueFromObject(null,'registered_nurse_signature'),                  
                },

                // 'Finish' Step 
                {}
            ],
            carePlanObject: carePlanObject,
            api_token: process.env.MIX_API_KEY,
        };
    },
    validations() {
        // Custom Validators
        const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
        const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
        const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
        const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
        const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

        const dateType = {
            required, 
            isDateFormat, 
            $lazy: true, 
            $autoDirty: true
        };
        
        const timeType = {
            required, 
            isTimeFormat, 
            $lazy: true, 
            $autoDirty: true
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false, allowSpecial = false) {
            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };                
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 0 - Plan Information
                { 
                    startDate: dateType,
                    expirationDate: dateType,
                    registeredNurseSignature: text(3, 191, true, true)
                },

                // 'Finish' Step 
                {}
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {
            // Validate fields on current step
            this.v$.step[this.currentStep].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep].$error) {                
                // All steps
                if (this.currentStep < this.maxStep - 1) {  // -1 because we don't need the 'finish step' here
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep - 1) { // -1 because we don't need the 'finish step' here
                    
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');
                    
                    var now = moment().format('DD/MM/YYYY');
                    var formData = {};
                    
                    // Loop through all steps
                    for(let i=0; i < this.maxStep; i++){                                        
                        for (const [key,value] of Object.entries(this.step[i])) {   
                            formData[key] = value;                     
                        }
                    }

                    // Add residentID and userID
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Activity";
                    

                    if (this.operation == 'store') {
                        this.createCarePlan(formData, toastError, alertSuccess);
                    }
                    else if (this.operation == 'copy') {                        
                        formData['interventions'] = JSON.stringify(this.carePlanObject['activity_care_plan']);                        
                        this.createCarePlan(formData, toastError, alertSuccess);                        
                    }
                    else if(this.operation == 'update') {
                        formData['updateType'] = 'update';
                        this.updateCarePlan(formData, toastError, alertSuccess);
                    }
                }                
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100); 
            }
        },
        onClickBack: function () {
            if (this.currentStep > 0) {
                this.currentStep--;
            }
            else {
                window.location = this.cancelUrl;
            }
            this.percentageComplete = Math.round((this.currentStep/ this.maxStep) * 100);
        },

        createCarePlan: function(formData, toastError, alertSuccess) {            
            // Call the store endpoint
            axios.post(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added to the DB. Thi
                            this.formSuccess = true;
                            window.residentId = this.residentId; 

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The activity care plan has been added.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Activity";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'warning', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },

        updateCarePlan: function(formData, toastError, alertSuccess) {            
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The activity care plan has been updated.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Activity";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        }        
        
    },
};
</script>
